import { Box, Icon, Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  type?: 'ai' | 'viridian'
}

export const ApplicationTopMatchTag = ({ type = 'ai' }: Props) => {
  return (
    <Tag inline type={type}>
      <Box flexDirection="row" gap="s8" alignItems="center">
        <Icon.Small icon="ai" color="grey800" />
        {i18n.t('ats.applications_table.top_match')}
      </Box>
    </Tag>
  )
}
